import { GroupedLicenseRow, LicenseRow } from "../../reducers/subscription/types";

// utils/subscription.js
export const statusMeta = {
  active: { color: "success", text: "ACTIVE" },
  canceled: { color: "default", text: "CANCELLED" },
  mixed: { color: "warning", text: "MIXED" },
};

export const currency = (n) =>
  new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(
    Number(n || 0)
  );

export const groupChildren = (children:LicenseRow[]) => {
  const map = new Map();
  children.forEach((c) => {
    
    const key = [c.service, c.plan, c.interval, Number(c.amount)].join("||");
    if (!map.has(key)) {
      map.set(key, {
        key,
        service: c.service,
        plan: c.plan,
        interval: c.interval,
        amount: Number(c.amount || 0),
        totalAmount : Number(c.totalAmount || 0),
        img: c.img,
        statuses: new Set([c.status]),
        items: [c],
      });
    } else {
      const g = map.get(key);
      g.items.push(c);
      g.statuses.add(c.status);
    }
  });

  return Array.from(map.values()).map((g) => ({
    ...g,
    count: g.items.length,
    status: g.statuses.size > 1 ? "mixed" : Array.from(g.statuses)[0],
    total: g.totalAmount * g.items.length,
  })) as GroupedLicenseRow[];
};

export const monthlyTotal = (license) => {
  if (!license) return 0;
  const parentMonthly = license.interval === "monthly" ? Number(license.amount || 0) : 0;
  const childrenMonthly = (license.children || [])
    .filter((c) => c.interval === "monthly")
    .reduce((sum, c) => sum + Number(c.amount || 0), 0);
  return parentMonthly + childrenMonthly;
};
